import React, { useState, useEffect, useRef, useMemo } from "react";
import { Link } from 'react-router-dom';
import { 
  Table, 
  Button, 
  Modal, 
  Form, 
  Input, 
  Select, 
  Switch, 
  Space, 
  Tag, 
  Popconfirm,
  message,
  Card,
  Row,
  Col,
  Typography,
  Tooltip,
  Drawer
} from 'antd';
import { 
  PlusOutlined, 
  EditOutlined, 
  DeleteOutlined, 
  SettingOutlined,
  UserOutlined,
  TeamOutlined,
  SearchOutlined,
  FilterOutlined
} from '@ant-design/icons';
import Api from "../../../../services/api";

const { Title } = Typography;
const { Option } = Select;

function User() {
    const [data, setData] = useState([]);
    const [user, setUser] = useState({});
    const [studios, setStudios] = useState([]);
    const [roles, setRoles] = useState([]);
    const [userType, setUserType] = useState('global'); 
    const [modal, setModal] = useState(false);
  const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [selectedRoles, setSelectedRoles] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const [form] = Form.useForm();
  const [filterParams, setFilterParams] = useState({});
  const [appliedFilters, setAppliedFilters] = useState({});
  const tableRef = useRef();
  const isResettingPage = useRef(false);
  
  
  const getDataWithPageCalled = useRef(new Set());
  const handleStudioDataCalled = useRef(false);
  const handleRoleDataCalled = useRef(false);

    const handleChangePage = (newPage) => {
        setPage(newPage);
        
        getDataWithPage(newPage);
    }

    const getDataWithPage = async (pageNumber = page) => {
      const cacheKey = `${pageNumber}-${JSON.stringify(appliedFilters)}`;
      if (getDataWithPageCalled.current.has(cacheKey)) return;
      getDataWithPageCalled.current.add(cacheKey);
      
      setLoading(true);
      try {
        
        const baseParams = new URLSearchParams();
        baseParams.append('page', pageNumber);
        Object.keys(appliedFilters).forEach(key => {
          if (appliedFilters[key] !== undefined && appliedFilters[key] !== null && appliedFilters[key] !== '') {
            baseParams.append(key, appliedFilters[key]);
          }
        });
        
        const url = `/api/admin?${baseParams.toString()}`;
        const response = await Api.get(url);
        if (!(response?.data?.code == 0)) { 
          setLoading(false); 
          return;
        }

        const incoming = response.data.data || {};
        setData(incoming);
      } catch (err) {
        console.error('API Error:', err);
      } finally {
        setLoading(false);
      }
    }

    const getRoleObjectsFromIds = (roleIds) => {
        if (!roleIds) return [];
        const ids = roleIds.map(id => String(id));
        return roles.filter(role => ids.includes(String(role.value)));
    };


    const handleStudioData = () => {
      if (handleStudioDataCalled.current) return;
      handleStudioDataCalled.current = true;
      
      Api.get(`/api/studios?page=${page}`)
      .then(result => {
        if (result?.data?.code == 0) {
          let data = [{
            code: null,
            name: "Chọn studio"
          }];
          result.data.data.map(i => {
              data.push({
              code: i.id,
              name: i.name,
              })
          });
          setStudios(data);
        }
        setLoading(false)
      });
    }

    const handleRoleData = () => {
      if (handleRoleDataCalled.current) return;
      handleRoleDataCalled.current = true;
      
      Api.get(`/api/roles`)
      .then(result => {
        if (result?.data?.code == 0) {
          
          const data = result.data.data.map(i => ({ value: String(i.id), label: i.name, studio_id: i.studio_id ?? null }));
          setRoles(data);
          
          setSelectedRoles(prev => {
            if (!prev || prev.length === 0) return prev;
            return prev.map(r => ({ value: String(r.value), label: r.label }));
          });
        }
        setLoading(false)
      });
    }

    const handleEditUser = (item) => {
      
      const roleObjects = (item.roles || []).map(i => ({ value: String(i.id), label: i.name }));

      setUser({
      id: item.id,
      name: item.name,
      email: item.email,
      studio_id: item.studio_id,
      is_admin: item.is_admin == 1 ? true : false,
      status: item.status == 'ACTIVE' ? true : false,
      roles: item.roles.map(i => i.id)
      });
      setUserType(item.studio_id ? 'studio' : 'global');
      
      

        
        setSelectedRoles(roleObjects);
        
        
        setIsAdmin(item.is_admin == 1);
        
    form.setFieldsValue({
      name: item.name,
      email: item.email,
      studio_id: item.studio_id,
      is_admin: item.is_admin == 1,
      status: item.status == 'ACTIVE',
      roles: item.roles && item.roles.length > 0 ? String(item.roles[0].id) : null,
      user_type: item.studio_id ? 'studio' : 'global'
    });
        setModal(true);
    }

    const handleCreateUser = () => {
        setUser({
            roles: []
        });
        setSelectedRoles([]);
        setIsAdmin(false);
    form.resetFields();
        setUserType('global');
        form.setFieldsValue({ user_type: 'global' });
        setModal(true);
    }

    const saveData = () => {
    form.validateFields().then(values => {
      setLoading(true);
      const payload = {
        name: values.name,
        email: values.email,
        is_admin: values.is_admin || false,
        status: values.status,
        roles: values.roles ? [values.roles] : []
      };
      
      
      if (userType === 'studio' && values.studio_id) {
        payload.studio_id = values.studio_id;
      }
      const api = user?.id ? Api.put(`/api/admin/${user.id}`, {
        ...payload
      }) : Api.post(`/api/admin`, {
        ...payload
      })
      
      api.then(result => {
        setLoading(false)
        if (result.data.code == 0) {
          message.success(user?.id ? 'Cập nhật user thành công!' : 'Tạo user thành công!');
          
          getDataWithPageCalled.current.clear();
          getDataWithPage(page);
          setUser({})
          setModal(false)
          form.resetFields();
        } else {
          message.error('Có lỗi xảy ra!');
        }
      }).catch(error => {
        setLoading(false);
        message.error('Có lỗi xảy ra!');
      });
      });
    }

    const handleRoleChange = (selectedOptions) => {
        setSelectedRoles(selectedOptions || []);
        form.setFieldValue('roles', (selectedOptions || []).map(option => option.value));
    }

    const handleDelete = (item) => {
        setLoading(true);
        Api.delete(`/api/admin/${item.id}`)
          .then(result => {
            setLoading(false);
        if (result.data.code == 0) {
          message.success('Xóa user thành công!');
          
          getDataWithPageCalled.current.clear();
          getDataWithPage(page);
        } else {
          message.error('Có lỗi xảy ra!');
        }
      }).catch(error => {
        setLoading(false);
        message.error('Có lỗi xảy ra!');
      });
  }

  const columns = [
    {
      title: 'Tên',
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => (
        <Space>
          <UserOutlined />
          <span>{text}</span>
        </Space>
      ),
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Studio',
      dataIndex: ['studio', 'name'],
      key: 'studio',
      render: (text, record) => (
        <Space>
          <TeamOutlined />
          <span>{text || 'Global'}</span>
        </Space>
      ),
    },
    {
      title: 'Quyền',
      key: 'role_group',
      render: (_, record) => {
        const isAdmin = record.is_admin === 1 || record.is_admin === true || record.is_admin === '1';
        const isGlobal = !record.studio_id;
        const hasOwnerRole = Array.isArray(record.roles) && record.roles.some(r => String(r.code || '').toLowerCase().includes('owner'));
        let label = 'User Studio';
        let color = 'blue';
        if (isAdmin) { label = 'Admin'; color = 'red'; }
        else if (isGlobal) { label = 'Global team'; color = 'geekblue'; }
        else if (hasOwnerRole) { label = 'Owner Studio'; color = 'gold'; }
        return <Tag color={color}>{label}</Tag>;
      },
    },
    {
      title: 'Trạng thái',
      dataIndex: 'status',
      key: 'status',
      render: (status) => (
        <Tag color={status === 'ACTIVE' ? 'green' : 'red'}>
          {status === 'ACTIVE' ? 'Hoạt động' : 'Không hoạt động'}
        </Tag>
      ),
    },
    {
      title: <span style={{ display: 'block', textAlign: 'center', width: '100%' }}>Hành động</span>,
      key: 'action',
      align: 'center',
      render: (_, record) => (
        <Space size="middle" style={{ justifyContent: 'center', width: '100%' }}>
          <Tooltip title="Phân quyền">
            <Link to={`/setting/users/${record.id}/permissions`}>
              <Button 
                type="primary" 
                icon={<SettingOutlined />} 
                size="small"
              />
            </Link>
          </Tooltip>
          <Tooltip title="Chỉnh sửa">
            <Button 
              type="default" 
              icon={<EditOutlined />} 
              size="small"
              onClick={() => handleEditUser(record)}
            />
          </Tooltip>
          <Tooltip title="Xóa">
            <Popconfirm
              title="Bạn có chắc chắn muốn xóa user này?"
              onConfirm={() => handleDelete(record)}
              okText="Có"
              cancelText="Không"
            >
              <Button 
                type="primary" 
                danger 
                icon={<DeleteOutlined />} 
                size="small"
              />
            </Popconfirm>
          </Tooltip>
        </Space>
      ),
    },
  ];

    
    useEffect(() => {
        
        if (!isResettingPage.current) {
            
            getDataWithPageCalled.current.clear();
            getDataWithPage(page);
        }
        
        isResettingPage.current = false;
    }, [page]);

    
    useEffect(() => {
        isResettingPage.current = true; 
        
        getDataWithPageCalled.current.clear();
        setPage(1); 
        getDataWithPage(1); 
    }, [appliedFilters]);

    
    useEffect(() => {
        handleStudioData();
        handleRoleData();
    }, []);

  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <>
      <div className="background-second-dashboard">
        <section className="main__content-dashbard">
          <div className="container-fluid">
            <Card>
              <Row justify="space-between" align="middle" style={{ marginBottom: '24px' }}>
                <Col>
                  <Title level={4} style={{ margin: 0, fontSize: '18px' }}>
                    Quản lý User
                  </Title>
                </Col>
                <Col>
                  <Button 
                    type="primary" 
                    icon={<PlusOutlined />}
                    onClick={handleCreateUser}
                    size="small"
                  >
                    Tạo User
                  </Button>
                </Col>
              </Row>

              {/* Filter Section */}
              <div className="mobile-search-toggle" style={{ display: 'none', position: 'fixed', bottom: '20px', right: '20px', zIndex: 1000 }}>
                <Button 
                  type="primary" 
                  shape="circle" 
                  icon={<SearchOutlined />} 
                  onClick={() => setDrawerOpen(true)} 
                  style={{ borderRadius: '50%', width: 48, height: 48, display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 2px 8px rgba(0,0,0,0.15)' }}
                />
              </div>
              <Card size="small" className="desktop-filter" style={{ marginBottom: '16px' }}>
                <Row gutter={[16, 16]} align="middle">
                  <Col xs={24} sm={12} md={4}>
                    <Input
                      placeholder="Tìm kiếm tên"
                      value={filterParams.name || ''}
                      onChange={(e) => {
                        const newFilterParams = { ...filterParams };
                        if (e.target.value) {
                          newFilterParams.name = e.target.value;
                        } else {
                          delete newFilterParams.name;
                        }
                        setFilterParams(newFilterParams);
                      }}
                      allowClear
                    />
                  </Col>
                  <Col xs={24} sm={12} md={4}>
                    <Input
                      placeholder="Tìm kiếm email"
                      value={filterParams.email || ''}
                      onChange={(e) => {
                        const newFilterParams = { ...filterParams };
                        if (e.target.value) {
                          newFilterParams.email = e.target.value;
                        } else {
                          delete newFilterParams.email;
                        }
                        setFilterParams(newFilterParams);
                      }}
                      allowClear
                    />
                  </Col>
                  <Col xs={24} sm={12} md={4}>
                    <Select
                      placeholder="Chọn studio"
                      value={filterParams.studio_name || undefined}
                      onChange={(value) => {
                        const newFilterParams = { ...filterParams };
                        if (value) {
                          newFilterParams.studio_name = value;
                        } else {
                          delete newFilterParams.studio_name;
                        }
                        setFilterParams(newFilterParams);
                      }}
                      allowClear
                      style={{ width: '100%' }}
                    >
                      <Option value="Global">Global</Option>
                      {studios.filter(s => s.code).map(studio => (
                        <Option key={studio.id} value={studio.name}>{studio.name}</Option>
                      ))}
                    </Select>
                  </Col>
                  <Col xs={24} sm={12} md={4}>
                    <Select
                      placeholder="Chọn quyền"
                      value={filterParams.role_group || undefined}
                      onChange={(value) => {
                        const newFilterParams = { ...filterParams };
                        if (value) {
                          newFilterParams.role_group = value;
                        } else {
                          delete newFilterParams.role_group;
                        }
                        setFilterParams(newFilterParams);
                      }}
                      allowClear
                      style={{ width: '100%' }}
                    >
                      <Option value="admin">Admin</Option>
                      <Option value="global">Global team</Option>
                      <Option value="owner">Owner Studio</Option>
                      <Option value="user">User Studio</Option>
                    </Select>
                  </Col>
                  <Col xs={24} sm={12} md={4}>
                    <Select
                      placeholder="Chọn trạng thái"
                      value={filterParams.status || undefined}
                      onChange={(value) => {
                        const newFilterParams = { ...filterParams };
                        if (value) {
                          newFilterParams.status = value;
                        } else {
                          delete newFilterParams.status;
                        }
                        setFilterParams(newFilterParams);
                      }}
                      allowClear
                      style={{ width: '100%' }}
                    >
                      <Option value="ACTIVE">Hoạt động</Option>
                      <Option value="UNACTIVE">Không hoạt động</Option>
                    </Select>
                  </Col>
                  <Col xs={24} sm={12} md={4}>
                    <Space>
                      <Button 
                        type="primary"
                        icon={<SearchOutlined />}
                        onClick={() => {
                          setAppliedFilters({...filterParams}); 
                        }}
                        size="small"
                      >
                        Apply
                      </Button>
                      <Button 
                        icon={<FilterOutlined />}
                        onClick={() => {
                          
                          setFilterParams({});
                          setAppliedFilters({});
                        }}
                        size="small"
                        disabled={Object.keys(filterParams).length === 0 && Object.keys(appliedFilters).length === 0}
                      >
                        Clear {(Object.keys(filterParams).length > 0 || Object.keys(appliedFilters).length > 0) && `(${Object.keys({...filterParams, ...appliedFilters}).length})`}
                      </Button>
                    </Space>
                  </Col>
                </Row>
              </Card>

              <Table
                ref={tableRef}
                columns={columns}
                dataSource={data.data || []}
                rowKey="id"
                loading={loading}
                bordered
                onChange={(pagination, filters, sorter) => {
                  if (pagination && pagination.current !== page) {
                    handleChangePage(pagination.current);
                  }
                }}
                pagination={{
                  current: page,
                  total: data.total || 0,
                  pageSize: data.per_page || 15,
                  showSizeChanger: false,
                  showQuickJumper: false,
                  showTotal: (total, range) => 
                    `${range[0]}-${range[1]} của ${total} user`,
                }}
                scroll={{ x: 1000 }}
              />
            </Card>
          </div>
        </section>
      </div>

      <Drawer
        title="Search Filters"
        placement="right"
        onClose={() => setDrawerOpen(false)}
        open={drawerOpen}
        width={320}
        className="mobile-filter-drawer"
        zIndex={2500}
      >
        <Row gutter={[16, 16]}>
          <Col xs={24}>
            <Input
              placeholder="Tìm kiếm tên"
              value={filterParams.name || ''}
              onChange={(e) => {
                const newFilterParams = { ...filterParams };
                if (e.target.value) newFilterParams.name = e.target.value; else delete newFilterParams.name;
                setFilterParams(newFilterParams);
              }}
              allowClear
            />
          </Col>
          <Col xs={24}>
            <Input
              placeholder="Tìm kiếm email"
              value={filterParams.email || ''}
              onChange={(e) => {
                const newFilterParams = { ...filterParams };
                if (e.target.value) newFilterParams.email = e.target.value; else delete newFilterParams.email;
                setFilterParams(newFilterParams);
              }}
              allowClear
            />
          </Col>
          <Col xs={24}>
            <Select
              placeholder="Chọn studio"
              value={filterParams.studio_name || undefined}
              onChange={(value) => {
                const newFilterParams = { ...filterParams };
                if (value) newFilterParams.studio_name = value; else delete newFilterParams.studio_name;
                setFilterParams(newFilterParams);
              }}
              allowClear
              style={{ width: '100%' }}
              options={[{ value: 'Global', label: 'Global' }, ...studios.filter(s => s.code).map(studio => ({ value: studio.name, label: studio.name }))]}
            />
          </Col>
          <Col xs={24}>
            <Select
              placeholder="Chọn quyền"
              value={filterParams.role_group || undefined}
              onChange={(value) => {
                const newFilterParams = { ...filterParams };
                if (value) newFilterParams.role_group = value; else delete newFilterParams.role_group;
                setFilterParams(newFilterParams);
              }}
              allowClear
              style={{ width: '100%' }}
              options={[
                { value: 'admin', label: 'Admin' },
                { value: 'global', label: 'Global team' },
                { value: 'owner', label: 'Owner Studio' },
                { value: 'user', label: 'User Studio' },
              ]}
            />
          </Col>
          <Col xs={24}>
            <Button 
              type="primary"
              icon={<SearchOutlined />}
              onClick={() => { setAppliedFilters({ ...filterParams }); setDrawerOpen(false); }}
              block
            >
              Apply
            </Button>
          </Col>
        </Row>
      </Drawer>
      <style>{`
        @media (max-width: 768px) {
          .desktop-filter { display: none !important; }
          .mobile-search-toggle { display: block !important; }
          .mobile-filter-drawer .ant-drawer-body { padding: 10px !important; }
        }
        @media (min-width: 769px) {
          .mobile-search-toggle { display: none !important; }
        }
      `}</style>

      <Modal
        title={user?.id ? 'Chỉnh sửa User' : 'Tạo User mới'}
        open={modal}
        onCancel={() => {
          setModal(false);
          form.resetFields();
        }}
        onOk={saveData}
        confirmLoading={loading}
        width={600}
      >
        <Form
          form={form}
          layout="vertical"
          initialValues={{
            status: true,
            is_admin: false,
            roles: [],
            user_type: 'global'
          }}
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Tên"
                name="name"
                rules={[{ required: true, message: 'Vui lòng nhập tên!' }]}
              >
                <Input placeholder="Nhập tên user" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Email"
                name="email"
                rules={[
                  { required: true, message: 'Vui lòng nhập email!' },
                  { type: 'email', message: 'Email không hợp lệ!' }
                ]}
              >
                <Input placeholder="Nhập email" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Loại user" name="user_type">
                <Select
                  onChange={(val) => {
                    setUserType(val);
                    if (val === 'global') {
                      form.setFieldsValue({ studio_id: null, is_admin: false, roles: [] });
                    } else {
                      form.setFieldsValue({ is_admin: false, roles: [] });
                    }
                  }}
                >
                  <Option value="global">Global</Option>
                  <Option value="studio">Studio</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Studio"
                name="studio_id"
                tooltip="Để trống = Global User"
              >
                <Select placeholder="Chọn studio" disabled={userType !== 'studio'}>
                  {studios.map(studio => (
                    <Option key={studio.code} value={studio.code}>
                      {studio.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          {!isAdmin && (
            <Form.Item
              label="Vai trò"
              name="roles"
            >
              <Select
                allowClear
                placeholder="Chọn vai trò..."
                options={roles.filter(r => r.studio_id == null)}
                optionFilterProp="label"
                value={form.getFieldValue('roles') || null}
                onChange={(value, optionObj) => {
                  setSelectedRoles(value ? [{ value: String(value), label: optionObj?.label }] : []);
                  form.setFieldValue('roles', value || null);
                }}
                style={{ width: '100%' }}
              />
            </Form.Item>
          )}

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Quyền Admin"
                name="is_admin"
                valuePropName="checked"
                tooltip="Bật = Admin (xem tất cả), Tắt = User thường"
              >
                <Switch 
                  checkedChildren="Admin" 
                  unCheckedChildren="User" 
                  onChange={(checked) => {
                    setIsAdmin(checked);
                    if (checked) {
                      
                      form.setFieldsValue({ 
                        user_type: 'global',
                        studio_id: null,
                        roles: [] 
                      });
                      setUserType('global');
                      setSelectedRoles([]);
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Trạng thái"
                name="status"
                valuePropName="checked"
              >
                <Switch 
                  checkedChildren="Hoạt động" 
                  unCheckedChildren="Không hoạt động" 
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
}

export default User;